<template>
  <div class="weight_setting">
    <div class="setting_box">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
        <el-form-item prop="attitude_score">
          <span slot="label">章节态度成绩<span><el-tooltip class="item" effect="dark" content="下列已选中选项平均" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip></span> </span>
          <el-input-number v-model="ruleForm.attitude_score" controls-position="right" :min="0" :max="100" :precision="0"></el-input-number><span style="margin-left: 10px;">%</span><span style="margin-left: 60px;color: red;">满分:
            100</span>
          <div class="list_box">
            <div class="list_item" :class="ruleForm.all_video==1?'seletc_list_item':''" @click="selectList('all_video')"><span class="icon_color"><i class="el-icon-success"></i></span>视频全部学习完成</div>
            <div class="list_item" :class="ruleForm.all_courseware==1?'seletc_list_item':''" @click="selectList('all_courseware')"><span class="icon_color"><i class="el-icon-success"></i></span>课件全部学习完成</div>
            <div class="list_item" :class="ruleForm.checkin_one==1?'seletc_list_item':''" @click="selectList('checkin_one')"><span class="icon_color"><i class="el-icon-success"></i></span>签到一次</div>
            <div class="list_item" :class="ruleForm.all_activities==1?'seletc_list_item':''" @click="selectList('all_activities')"><span class="icon_color"><i class="el-icon-success"></i></span>投票、讨论、抢答、教师n个动作、系统累计n个动作</div>
          </div>
        </el-form-item>
        <el-form-item prop="knowledge_score">
          <span slot="label">章节知识成绩<span> <el-tooltip class="item" effect="dark" content="章节习题测试成绩" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip></span> </span>
          <el-input-number v-model="ruleForm.knowledge_score" controls-position="right" :min="0" :max="100" :precision="0"></el-input-number><span style="margin-left: 10px;">%</span><span style="margin-left: 60px;color: red;">满分:
            100</span>
        </el-form-item>
        <el-form-item prop="practice_score">
          <span slot="label">章节实训成绩<span></span> </span>
          <el-input-number v-model="ruleForm.practice_score" controls-position="right" :min="0" :max="100" :precision="0"></el-input-number><span style="margin-left: 10px;">%</span><span style="margin-left: 60px;color: red;">满分:
            100</span>
        </el-form-item>
        <el-form-item prop="literacy_score">
          <span slot="label">章节素养成绩<span></span> </span>
          <el-input-number v-model="ruleForm.literacy_score" controls-position="right" :min="0" :max="100" :precision="0"></el-input-number><span style="margin-left: 10px;">%</span><span style="margin-left: 60px;color: red;">满分:
            100</span>
        </el-form-item>
        <p>总成绩</p>
        <el-form-item prop="chapter_score">
          <span slot="label">章节成绩<span> <el-tooltip class="item" effect="dark" content="各章节成绩平均分" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip></span> </span>
          {{ ruleForm.chapter_score }}<span style="margin-left: 10px;">%</span>
        </el-form-item>
        <el-form-item prop="exam_score">
          <span slot="label">考试成绩<span><el-tooltip class="item" effect="dark" content="章节*(100%-考试成绩百分比)+所有考试平均成绩*考试成绩百分比(仅结束的考试参与计算,如无已结束的考试该项不参与)" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip></span> </span>
          <el-input-number v-model="ruleForm.exam_score" controls-position="right" @change="handleChange" :min="0" :max="100" :precision="0"></el-input-number><span style="margin-left: 10px;">%</span>
        </el-form-item>
      </el-form>
      <div class="button_box">
        <el-button @click="cancle">取消</el-button>
        <el-button style="background: #4F7BFD;color: #fff;" @click="confirm('ruleForm')">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      ruleForm: {
        course_id: Number(this.$route.query.course_id) || localStorage.getItem("course_id"),
        class_id: Number(localStorage.getItem("class_id")),
        chapter_score: void 0,
        exam_score: void 0,
        literacy_score: void 0,
        practice_score: void 0,
        knowledge_score: void 0,
        attitude_score: void 0,
        all_video: 0,
        all_courseware: 0,
        checkin_one: 0,
        all_activities: 0,
      },
      rules: {
        attitude_score: [
          { required: true, message: "请输入分值", trigger: "blur" },
        ],
        knowledge_score: [
          { required: true, message: "请输入分值", trigger: "blur" },
        ],
        practice_score: [
          { required: true, message: "请输入分值", trigger: "blur" },
        ],
        literacy_score: [
          { required: true, message: "请输入分值", trigger: "blur" },
        ],
        chapter_score: [
          { required: true, message: "请输入分值", trigger: "blur" },
        ],
        exam_score: [
          { required: true, message: "请输入分值", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getSettingWeight()
  },
  methods: {
    handleChange() {
      this.ruleForm.chapter_score = 100 - this.ruleForm.exam_score;
    },
    cancle() {
      this.$router.push({path:"/qualityCourse/teacher/index",query:{course_id:this.$route.query.course_id}});
    },
    selectList(value) {
      this.ruleForm[value] = this.ruleForm[value] === 0 ? 1 : 0;
      console.log(this.ruleForm[value], " this.ruleForm[value]");
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            !this.ruleForm.all_video &&
            !this.ruleForm.all_courseware &&
            !this.ruleForm.checkin_one &&
            !this.ruleForm.all_activities
          ) {
            this.$message.warning("请选择完成条件限制");
            return;
          }
          let sum =
            this.ruleForm.literacy_score +
            this.ruleForm.practice_score +
            this.ruleForm.knowledge_score +
            this.ruleForm.attitude_score;
          if (sum != 100) {
            this.$message.warning(
              "语言表达清晰度和章节知识成绩,实训成绩.素养成绩总比例为100"
            );
            return;
          }
          this.$shttp.axiosPost(
            this.$api.jdCourseScoreRatio,
            this.ruleForm,
            (res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "权重设置成功",
                });
                this.$router.push({path:"/qualityCourse/teacher/index",query:{course_id:this.$route.query.course_id}});
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            },
            (err) => {
              console.log(err);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getSettingWeight() {
      let params = {
        course_id: Number(this.$route.query.course_id),
        class_id: Number(localStorage.getItem("class_id")),
      };
      // jdCourseScoreRatioInfo
      this.$shttp.axiosPost(
        this.$api.jdCourseScoreRatioInfo,
        params,
        (res) => {
          if (res.code === 200) {
            if(res.data.length==0)return
            this.ruleForm.chapter_score = res.data.chapter_score;
            this.ruleForm.exam_score = res.data.exam_score;
            this.ruleForm.literacy_score = res.data.literacy_score;
            this.ruleForm.practice_score = res.data.practice_score;
            this.ruleForm.knowledge_score = res.data.knowledge_score;
            this.ruleForm.attitude_score = res.data.attitude_score;
            this.ruleForm.all_video = res.data.all_video;
            this.ruleForm.all_courseware = res.data.all_courseware;
            this.ruleForm.checkin_one = res.data.checkin_one;
            this.ruleForm.all_activities = res.data.all_activities;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.weight_setting {
  width: 100%;
  height: 100%;
  padding: 30px 40px;
  box-sizing: border-box;
  .setting_box {
    width: 100%;
    height: 100%;
    background: #fff;
    padding: 30px 40px;
    box-sizing: border-box;
  }
  .button_box {
    display: flex;
    justify-content: center;
    .el-button {
      margin-top: 30px;
      width: 88px;
      height: 36px;
      background: #f2f4f7;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #3e3e3e;
      line-height: 16px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }
  .list_box {
    .list_item {
      cursor: pointer;
      display: flex;
      align-items: center;
      .icon_color {
        margin-right: 10px;
        font-size: 17px;
        color: #aaabad;
      }
    }
    .seletc_list_item {
      color: #02be00;
      .icon_color {
        color: #02be00;
      }
    }
  }
}
::v-deep .el-input__inner {
  background: #fff;
  &:focus {
    border-color: #dcdfe6;
  }
  color: #333;
  // width: 130px;
  // height: 28px;
}
::v-deep .el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: transparent !important;
}
::v-deep .el-input-number.is-controls-right .el-input-number__decrease{
  bottom: 2px;
  line-height: 16px !important;
}
::v-deep  .el-input-number__increase{
  top: 3px !important;
  line-height: 16px !important;
}


</style>
